import { createContext } from 'react';

// The signed-in app's router navigate(), provided once by CRMApp. Components that navigate from a handler read it through
// hooks/useAppNavigate instead of importing react-router-dom (which this Jest setup cannot resolve).
const AppNavigateContext = createContext(null);

export default AppNavigateContext;
